import { useQuery } from '@tanstack/react-query';
import apiClient from 'services/apiClient';

export const CAMPAIGN_DETAIL_KEY_PREFIX = ['campaign-detail'];
export const campaignDetailKey = (campaignID, dateRangeID) =>
    [...CAMPAIGN_DETAIL_KEY_PREFIX, campaignID, dateRangeID];

const useCampaignDetail = (campaignID, dateRangeID) => useQuery(
    campaignDetailKey(campaignID, dateRangeID),
    () => apiClient
        .get(`/Statistics/Campaign/${campaignID}`, {
            params: { CampaignID: campaignID, DateRangeItemID: dateRangeID },
        })
        .then(r => r.data),
    { enabled: !!campaignID && campaignID > 0, staleTime: 5 * 60 * 1000 }
);

export default useCampaignDetail;
